// ERP模块的Vuex store
import { to } from '@/utils/utils'
import { getLowerAgentStoreInfoOneSelf } from '@/utils/http/modules/agent/erp.request'

const state = {
  storeList: [], // 门店列表
  currentStore: null, // 当前选中的门店
  storeListPagination: {
    pageIndex: 1,
    pageSize: 20,
    totalRows: 0,
    loading: false,
    finished: false,
  },
}

const mutations = {
  SET_STORE_LIST(state, storeList) {
    state.storeList = storeList
  },
  APPEND_STORE_LIST(state, stores) {
    state.storeList = [...state.storeList, ...stores]
  },
  SET_CURRENT_STORE(state, store) {
    state.currentStore = store
  },
  // 分页相关的mutations
  SET_STORE_LIST_LOADING(state, loading) {
    state.storeListPagination.loading = loading
  },
  SET_STORE_LIST_FINISHED(state, finished) {
    state.storeListPagination.finished = finished
  },
  SET_STORE_LIST_TOTAL(state, total) {
    state.storeListPagination.totalRows = total
  },
  INCREMENT_STORE_LIST_PAGE(state) {
    state.storeListPagination.pageIndex++
  },
  RESET_STORE_LIST_PAGINATION(state) {
    state.storeListPagination = {
      ...state.storeListPagination,
      pageIndex: 1,
      finished: false,
    }
    state.storeList = []
  },
}

const actions = {
  // 获取代理绑定的门店列表
  async fetchStoreList(
    { commit, state },
    { isRefresh = false, storeName = '' } = {}
  ) {
    // 如果是刷新，重置分页信息
    if (isRefresh) {
      commit('RESET_STORE_LIST_PAGINATION')
    }

    // 如果已经加载完成，直接返回
    if (state.storeListPagination.finished && !isRefresh) {
      return
    }

    // 设置加载状态
    commit('SET_STORE_LIST_LOADING', true)

    const [err, res] = await to(
      getLowerAgentStoreInfoOneSelf({
        pageIndex: state.storeListPagination.pageIndex,
        pageSize: state.storeListPagination.pageSize,
        storeName,
        zbId: window.zbvd.zbid,
      })
    )

    // 设置加载状态为false
    commit('SET_STORE_LIST_LOADING', false)

    if (!err && res?.dataObj) {
      const newStores =
        res.dataObj.rows.map(item => {
          return {
            id: item.storeId,
            name: item.storeName,
          }
        }) || []

      // 更新总数
      commit('SET_STORE_LIST_TOTAL', res.dataObj.totalRows || 0)

      // 如果是刷新，替换列表；否则，追加到列表
      if (isRefresh) {
        commit('SET_STORE_LIST', newStores)
      } else {
        commit('APPEND_STORE_LIST', newStores)
      }

      // 更新页码
      commit('INCREMENT_STORE_LIST_PAGE')

      // 检查是否加载完成
      if (state.storeList.length >= state.storeListPagination.totalRows) {
        commit('SET_STORE_LIST_FINISHED', true)
      } else {
        commit('SET_STORE_LIST_FINISHED', false)
      }

      // 默认选中第一家门店（如果没有选中的门店）
      if (state.storeList.length > 0 && !state.currentStore) {
        commit('SET_CURRENT_STORE', state.storeList[0])
      }

      return {
        success: true,
        data: newStores,
      }
    }

    return {
      success: false,
      error: err,
    }
  },
  // 切换当前门店
  changeCurrentStore({ commit }, store) {
    commit('SET_CURRENT_STORE', store)
  },
}

const getters = {
  storeList: state => state.storeList,
  currentStore: state => state.currentStore,
  storeListPagination: state => state.storeListPagination,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
